import axios from 'axios';
import { adminServerUrl } from '@goodsteward/gs-ui/adminServerUrl';
import { useScopedMutation } from '@/lib/scopedQuery';
import { useAuthStore } from '@/stores/auth';

export type FeedbackType = 'improvement' | 'bug';

export interface SubmitFeedbackInput {
    type: FeedbackType;
    message: string;
    pagePath: string;
}

// POSTs cross-origin to admin-server's /api/support/feedback so the
// submission lands in the support_feedback table that the admin SPA
// already triages. The endpoint accepts any platform Cognito user, so
// the PMA user's bearer token is the only auth we need.
//
// admin-server's CORS layer (app.js parses SUPPORT_ALLOWED_ORIGINS)
// must list the PMA origin in each environment — local dev, test, prod.
export function useSubmitFeedback() {
    return useScopedMutation({
        mutationFn: async (input: SubmitFeedbackInput) => {
            const token = useAuthStore.getState().token;
            // The body field is what the admin UI renders. Prefix with
            // the user-selected category so triage can read "[Bug] …"
            // vs "[Improvement] …" without a separate schema column —
            // support_feedback is shared with the public support site
            // (which has no type concept), and a body prefix avoids
            // growing the table for one app.
            const body = `[${input.type === 'bug' ? 'Bug' : 'Improvement'}] ${input.message}`;
            await axios.post(
                `${adminServerUrl('pma')}/api/support/feedback`,
                {
                    page_slug: input.pagePath || '/',
                    page_url:  typeof window !== 'undefined' ? window.location.href : input.pagePath,
                    body,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                    timeout: 15_000,
                },
            );
        },
    });
}
